import React from "react";
import Typography from "@material-ui/core/Typography";

export default function Title(props) {
	return (
		<Typography
			variant="h5"
			color="primary"
			gutterBottom
			style={{ flex: "0 1 auto", minWidth: 0, overflowWrap: "anywhere", marginBottom: 0 }}
		>
			{props.children}
		</Typography>
	);
}
